import React, { useContext, useState } from "react";
import CourseInfoBox from "../CourseInfoBox/CourseInfoBox";
import "./CourseRulesComponent.css";
import { BsCheck2 } from "react-icons/bs";
import { BsBookmark, BsFillBookmarkFill } from "react-icons/bs";
import { SlBasketLoaded } from "react-icons/sl";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { addToBasket } from "../../Helpers/basketHelper";
import { CartContext } from "../../Hooks/CartContext";

export default function CourseRulesComponent({ courseData }) {
    const [isLike, setIsLike] = useState(courseData.isSaved);
    const { cartItems, addToCart } = useContext(CartContext);

    const nav = useNavigate();

    function saveCourse() {
        axiosConfig
            .post("api/Courses/CourseSave/" + courseData.id)
            .then((result) => {
                toast.success("با موفقیت دوره سیو شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setIsLike(true);
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    nav("/login");
                }
            });
    }
    function deleteSaveCourse() {
        axiosConfig
            .delete("api/Courses/CourseSave/" + courseData.id)
            .then((result) => {
                toast.success("با موفقیت دوره سیو شده حذف شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setIsLike(false);
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    nav("/login");
                }
            });
    }
    return (
        <div className="course-rules">
            <CourseInfoBox courseData={courseData} />
            <div className="course-rules-box">
                <div className="course-rules-box-text">
                    <h3>قوانین خرید دوره</h3>
                </div>
                <ul>
                    <li>
                        <BsCheck2 />
                        ویدیو ها لایسنس دارند
                    </li>
                    <li>
                        <BsCheck2 />
                        پشتیبانی ۲۴ ساعته
                    </li>
                    <li>
                        <BsCheck2 />
                        دسترسی همیشگی به دوره ها
                    </li>
                    <li>
                        <BsCheck2 />
                        تضمین کسب درآمد از دوره
                    </li>
                </ul>
            </div>
            <div className="course-rules-btn">
                <button
                    onClick={async () => {
                        // i know , 0 is not readable , but it means course
                        const res = await addToBasket(courseData.id, 0, 1);
                        if (res) addToCart(cartItems + 1)
                    }}
                >
                    <SlBasketLoaded />
                    اضافه کردن به سبد خرید
                </button>
                <div className="course-rules-btn-save">
                    {isLike ? (
                        <BsFillBookmarkFill onClick={deleteSaveCourse} />
                    ) : (
                        <BsBookmark onClick={saveCourse} />
                    )}
                </div>
            </div>
        </div>
    );
}
